import { protectedClient } from '@/lib/api.ts';

const meQueryFn = async () => {
  const { data } = await protectedClient.get('/me');
  return data;
};

export default meQueryFn;
